/* Copyright (c) 2022 MOCA Systems, Inc. All rights reserved. */

import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { cssThemes } from 'src/app/app-data/constants/cssThemes';
import { GenericDialogComponent } from 'src/app/common/generic-dialog/generic-dialog.component';

@Component({
	selector: 'allowed-links-editor',
	templateUrl: './allowed-links-editor.component.html',
	styleUrls: ['./allowed-links-editor.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AllowedLinksEditorComponent extends GenericDialogComponent implements OnInit, OnDestroy {
	public linksString = new UntypedFormControl('');

	public onButtonSaveSelect() {
		this.dialogRef.close({ value: this.linksString.value });
	}
	public ngOnInit(): void {
		this.data.dataObservable
			.pipe(
				takeUntil(this.destroy$),
				map((arr) => {
					if (!arr || !arr.length) {
						return null;
					}
					return arr.join(', ');
				})
			)
			.subscribe((str) => this.linksString.setValue(str, { emitEvent: false }));
	}
}
